/* Copyright (c) 2018-2023, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export interface StackTraceType {
    name: string;
    message: string;
    stackFrame: string;
    exceptionString: string;
    clientType?: string;
}

export const ExceptionRegex = {
    Sanitize: /(\w+:|[\\/]).*[\\/]/gi,
    Indentation: / at /g,
    // TODO: Evanluate if `Class` can be removed entirely.
    Class: /([^]+)/g
};

export const ExceptionHtmlConstants = {
    Indentation: '<br>&nbsp;&nbsp;&nbsp;at ',
    // TODO: Evaluate if `Class` can be removed entirely.
    Class: '<span>$1</span>'
};

export interface ExceptionMetadata {
    [key: string]: any;
}
export class NVException extends Error {
    private readonly err: any;
    private metadata: ExceptionMetadata;
    private errorMessage: string;

    constructor(message: string, error: any) {
        // Extends Error so the global ErrorHandler classifies these as real errors. Previously they fell into
        // its "unknown error" branch, which dropped the telemetry event and rendered a content-free dialog.
        super(message);
        this.name = new.target.name;
        this.err = error;
        this.errorMessage = message;
        this.metadata = {};
    }

    get error(): any {
        return this.err;
    }

    toString(): string {
        return this.errorMessage + ':' + JSON.stringify(this.err);
    }

    addMetadata(key: string, value: any) {
        this.metadata[key] = value;
    }

    getMetaData(): ExceptionMetadata {
        return this.metadata;
    }
}
